import { useState } from 'react';

const Tooltip = (props) => {
    const [isVisible, setIsVisible] = useState(false);

    const wrapperStyle = {
        position: "relative",
        display: "inline-block"
    }

    const contentStyle = {
        position: "absolute",
        top: "100%", 
        left: "50%",
        transform: "translateX(-50%)",
        marginTop: "5px",
        padding: "6px 10px",
        backgroundColor: "#FFFFFF",
        color: "#333333",
        fontSize: "14px",
        fontWeight: "400",
        border: "1px solid #CCCCCC",
        borderRadius: "8px",
        whiteSpace: "nowrap",
        zIndex: 9999,
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
        pointerEvents: "none"
    }

    return (
        <div className="tooltip-wrapper" style={wrapperStyle} onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
            {props.children}
            {isVisible && <div className="tooltip-content" style={contentStyle}>{props.content}</div>}
        </div>
    );
}
export default Tooltip;